import { formatSizeAsFraction } from '../../../modules/size_formatter'

export function handleSpecialOrderColorClick(button) {
  const selectedColor = button.dataset.specialOrderColor
  const stateElement = document.getElementById('product-selection-state')
  
  if (!stateElement) return
  
  const selectedSize = stateElement.getAttribute('data-size')
  
  if (!selectedSize) {
    hideSpecialOrderDisplay()
    return
  }
  
  const selectedSizeDisplay = formatSizeAsFraction(selectedSize)
  const isCurrentlySelected = button.classList.contains('selected')
  
  clearAllSelections()
  
  if (isCurrentlySelected) {
    hideSpecialOrderDisplay()
  } else {
    button.classList.add('selected')
    showSpecialOrderDisplay(selectedSizeDisplay, selectedColor)
  }
}

function clearAllSelections() {
  document.querySelectorAll('.special-order-color-button').forEach(btn => {
    btn.classList.remove('selected')
  })
}

function hideSpecialOrderDisplay() {
  const display = document.getElementById('special-order-selection-display')
  if (display) {
    display.style.display = 'none'
  }
}

function showSpecialOrderDisplay(size, color) {
  const display = document.getElementById('special-order-selection-display')
  const colorDisplay = document.getElementById('special-order-color-display')
  
  if (colorDisplay) {
    colorDisplay.textContent = color
  }
  
  if (display) {
    display.style.display = 'block'
  }
}
